<template>
  <div>
    <b-breadcrumb :items="$options.breadcrumb"/>
    <b-card-group deck>
      <b-card
        title="Teamleader"
        img-src="@/assets/img/TL-icon-RGB.svg"
        img-top
        style="min-width: 15rem; max-width: 15rem;"
        img-height="150px"
        class="mb-2"
      >
        <b-card-text>
          <p>Teamleader verenigt CRM, projectmanagement en facturatie in één eenvoudige en intelligente tool die bedrijven helpt om slimmer te werken.</p>
        </b-card-text>

        <b-button
          variant="primary"
          :href="`https://app.teamleader.eu/oauth2/authorize?client_id=38fd82c327f58f733ecc58361996ec2c&response_type=code&redirect_uri=${tlRedirect}`"
        >Activeer</b-button>
      </b-card>
    </b-card-group>
  </div>

</template>

<script>

export default
{
    breadcrumb:
    [
        { text: 'Configuratie' },
        { text: 'Integraties', active: true }
    ],
    data()
    {
        let tlRedirect = 'https://bigfox.app/main/integration/teamleader';

        if(process.env.NODE_ENV === 'development')
            tlRedirect = 'http://localhost:8080/main/integration/teamleader';

        return {
            tlRedirect
        };
    }
}
</script>

<style>
</style>